<template>
    <div class="train-box">
        <div class="top-box">
            <div class="btn-box" @click="publishTrainTask">
                <i class="iconfont icon-jiahao"></i>
                发布实训任务
            </div>
            <div class="input-box">
                <div @click="search">搜索</div>
                <el-input v-model="pages.keywords" style="width: 20rem;" @keydown.enter.native="search" clearable @clear="search" placeholder="请输入关键字">
                    <template slot="prefix">
                        <div class="search-ipt-box">
                            <img style="cursor: pointer;width: 16px;height: auto;" src="../../../assets/image/magSys/search.png" @click="search" alt="">
                        </div>
                    </template>
                </el-input>
            </div>
        </div>
        <div class="train-content">
            <no-data v-if="trainList.length==0"></no-data>
            <div v-for="(item,index) in trainList" class="train-item" :key="index">
                <div class="el-box">
                    <div class="item-top">
                        <div class="title-box">
                            <img :class="{'open-active':item.id==currentTaskId}" @click="openChild(item)" src="../../../assets/image/other/down.png" alt="">
                            <p class="item-name overflow" @click="openChild(item)">{{ item.taskName }}</p>
                            <div class="status-label" :style="`background-color:${filterStatus(item.taskStatus).color};`">{{ filterStatus(item.taskStatus).label }}</div>
                        </div>
                        <div class="operation-box">
                            <el-tooltip class="item" effect="dark" content="详情" placement="top-start">
                                <i class="iconfont icon-xiangqing" @click="detailTask(item)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <i class="iconfont icon-bianji1" @click="editTask(item)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <i class="iconfont icon-shanchu" @click="removeTask(item.id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="item-bottom">
                        <div class="el-btm">
                            <p>所属软件：</p>
                            <el-tooltip effect="dark" :content="item.softwareNames" placement="top-start">
                                <p style="width: 38rem;" class="overflow">{{ item.softwareNames }}</p>
                            </el-tooltip>
                        </div>
                        <div class="el-btm">
                            <p>开始时间：</p>
                            <p>{{ item.beginTime }}</p>
                        </div>
                        <div class="el-btm">
                            <p>结束时间：</p>
                            <p>{{ item.endTime }}</p>
                        </div>
                        <div class="el-btm">
                            <p>已练习人员：</p>
                            <p>{{ item.completed }}</p>
                        </div>
                        <div class="el-btm">
                            <p>未练习人员：</p>
                            <p>{{ item.incomplete }}</p>
                        </div>
                        <div class="el-btm">
                            <p>发布时间：</p>
                            <p>{{ item.publishTime }}</p>
                        </div>
                    </div>
                </div>
                <div class="child-box" :style="`max-height:${item.id==currentTaskId?(computedHeight(trainingRecordList)+'rem'):'0px'};`">
                    <div class="t-head">
                        <p>序号</p>
                        <p>姓名</p>
                        <p>班级</p>
                        <p>实训时长</p>
                        <p>合格率</p>
                        <p>实训最高分</p>
                        <p>实训次数</p>
                        <p>最后提交时间</p>
                    </div>
                    <div class="t-body-item" v-for="(el,i) in trainingRecordList" :key="i">
                        <p>{{ i+1 }}</p>
                        <p>{{ el.userName||'/' }}</p>
                        <p>{{ el.className||'/' }}</p>
                        <p>{{ el.onlineTime||'/' }}</p>
                        <p>{{ el.passRate==null?'/':(el.passRate+'%') }}</p>
                        <p>{{ el.maxScore==null?'/':el.maxScore }}</p>
                        <p @click="viewDetail(item,el)" class="blue-color">{{ el.trainingCount==null?'/':el.trainingCount }}</p>
                        <p>{{ el.lastSubmitTime||'/' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <publist-train ref="publish_train" @save_task="pageQueryTask"></publist-train>
        <pratical-detail ref="pratical_detail"></pratical-detail>
        <task-detail ref="task_detail"></task-detail>
    </div>
</template>

<script>
import PublistTrain from './PublistTrain.vue';
import { PageQueryTask,PageQueryTrainingRecord,RemoveTask,GetTaskDetail } from '@/api/trainTask';
import NoData from '../../common/NoData.vue';
import PraticalDetail from '../../personCenter/myselfTask/PraticalDetail.vue';
import TaskDetail from './TaskDetail.vue';
    export default {
  components: { PublistTrain, NoData, PraticalDetail, TaskDetail },
        data(){
            return {
                pages:{
                    current:1,
                    size:10,
                    keywords:'',
                    total:0
                },
                /**第二级分页 */
                secondPages:{
                    current:1,
                    size:10,
                    total:0
                },
                /**实训任务列表 */
                trainList:[],
                /**当前展开的任务id */
                currentTaskId:'',
                /**实训记录列表 */
                trainingRecordList:[]
            }
        },
        methods:{
            search(){
                this.pageQueryTask();
            },
            filterStatus(status){
                var obj={
                    0:{
                        label:'未开始',
                        color:'#C2C7D9'
                    },
                    1:{
                        label:'进行中',
                        color:'#387DFF'
                    },
                    2:{
                        label:'已结束',
                        color:'#67C23A'
                    },
                }
                return obj[status]||{};
            },
            /**查看任务详情 */
            detailTask(item){
                GetTaskDetail({id:item.id}).then(res=>{
                    if(res.code==200){
                        let dialog=this.$refs.task_detail;
                        if(dialog){
                            dialog.dialogVisible=true;
                            dialog.detail=res.data;
                        }
                    }
                })
            },
            /**查看实训得分详情 */
            viewDetail(item,el){
                let dialog=this.$refs.pratical_detail;
                if(dialog){
                    dialog.taskId=item.id;
                    dialog.title=item.taskName;
                    dialog.pages.current=1;
                    dialog.userId=el.userId;
                    dialog.pageQueryUserTrainingRecord();
                }
            },
            /**编辑实训任务 */
            editTask(item){
                GetTaskDetail({id:item.id}).then(res=>{
                    if(res.code==200){
                        let dialog=this.$refs.publish_train;
                        if(dialog){
                            dialog.dialogVisible=true;
                            dialog.operation='edit';
                            dialog.getClassList();
                            dialog.search();
                            let softwareIds=res.data.refSoftWareInfoList.map(e=>{
                                return {
                                    id:e.originalId,
                                    resType:e.resType,
                                    url:e.url
                                }
                            });
                            let classIds=res.data.refClassInfoList.map(e=>e.id);
                            var form={
                                name:item.taskName,
                                startTime:item.beginTime,
                                endTime:item.endTime,
                                softwareIds:softwareIds,
                                classes:classIds
                            };
                            dialog.form=form;
                            dialog.taskId=item.id;
                        }
                    }
                })
            },
            /**删除实训任务 */
            removeTask(id){
                this.$confirm('是否确认删除该条数据?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    RemoveTask({id}).then(res=>{
                    if(res.code==200){
                        this.$msg({
                        showClose: true,
                        type: 'success',
                        message: '删除成功'
                        });
                        if(this.trainList.length==1&&this.pages.current>1){
                            this.pages.current--;
                        }
                        this.pageQueryTask();
                    }
                })
                  });
            },
            /**分页查询实训任务 */
            pageQueryTask(){
                let params={
                "current": this.pages.current,
                "size": this.pages.size,
                "taskName": this.pages.keywords,
                "taskStatus": ""
                }
                PageQueryTask(params).then(res=>{
                    if(res.code==200){
                        this.trainList=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            /**根据任务id分页查询实训记录 */
            pageQueryTrainingRecord(){
                this.trainingRecordList=[];
                this.secondPages.total=0;
                var params={
                "current": this.secondPages.current,
                "size": this.secondPages.size,
                "taskId": this.currentTaskId
                }
                PageQueryTrainingRecord(params).then(res=>{
                    if(res.code==200){
                        this.trainingRecordList=res.data.records;
                        this.secondPages.total=res.data.total;
                    }
                })
            },
            /**计算最大高度 */
            computedHeight(data){
                if(data&&data.length>0){
                    return 5.3*(data.length+1);
                }else{
                    return 0;
                }
            },
            /**发布实训任务 */
            publishTrainTask(){
                let dialog=this.$refs['publish_train'];
                if(dialog){
                    dialog.dialogVisible=true;
                    dialog.operation='add';
                    dialog.getClassList();
                    dialog.search();
                }
            },
            /**展开 */
            openChild(item){
                if(item.id==this.currentTaskId){
                    this.currentTaskId='';
                    return;
                }
                this.currentTaskId=item.id;
                this.pageQueryTrainingRecord();
            }
        },
        mounted(){
            this.pageQueryTask();
        }
    }
</script>

<style lang="less" scoped>
.train-box{
    height: 100%;
    color: #334681;
    .top-box{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
}
.train-content{
    height: calc(100% - 6rem);
    overflow: auto;
    margin-top: 2rem;
    border: 1px solid #e0e8f2;
    border-radius: 1rem 1rem 0px 0px;
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.input-box{
    display: flex;
    align-items: center;
    color: #334681;
    &> :nth-child(1){
        margin-right: 1.3rem;
        cursor: pointer;
        color: #8590B3;
    }
}
.input-box{
/deep/.el-input__inner{
    height: 4rem;
    border-radius: 1rem;
    padding-left: 3.5rem;
}
.search-ipt-box{
    display: flex;
    align-items: center;
    width: 3.5rem;
    justify-content: center;
    height: 100%;
}
}
.table-content-box{
    height: calc(100% - 4rem);
    padding: 2rem 0 1rem 0;
}
.operation-box{
    display: flex;
    &> :nth-child(n){
        margin-left: 16px;
        color: var(--blue);
        cursor: pointer;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
    i{
        font-size: 16px;
    }
}
.item-top{
    display: flex;
    justify-content: space-between;
    .title-box{
        display: flex;
        align-items: center;
        img{
            width: 16px;
            height: auto;
            object-fit: cover;
            cursor: pointer;
            transition: all 0.3s;
            margin-right: 1rem;
            transform: rotate(-90deg);
        }
    }
}
.item-name{
    font-weight: 700;
    font-size: 16px;
    cursor: pointer;
}
.status-label{
    padding:0.2rem 0.2rem;
    background: #c2c7d9;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
    margin-left: 1rem;
}
.item-bottom{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #8590B3;
    margin-top: 12px;
    overflow: hidden;
    &> :nth-child(n){
        margin-left: 4.5rem;
    }
    &> :nth-child(1){
        margin-left: 2.5rem;
    }
    .el-btm{
        display: flex;
    }
}
.el-box{
    padding: 2.2rem 4.5rem;
    border-bottom: 1px solid #e0e8f2;
}
.child-box{
    background-color: #E0E8F2;
    transition: all 0.3s;
    overflow: hidden;
    .t-head{
        display: flex;
        padding: 1.7rem 4rem;
        &> :nth-child(n){
            flex: 1;
        }
    }
}
.t-body-item{
    display: flex;
    padding: 1.7rem 4rem;
    &> :nth-child(n){
        flex: 1;
    }
}
.open-active{
    transform: rotate(0) !important;
}
/deep/.backimg{
    height: 100%;
}
.blue-color{
    color: var(--blue);
    cursor: pointer;
}
</style>